module.exports = __webpack_public_path__ + "static/media/location_icon_selected.179e4fd1.svg";